import React from 'react';
import { getProductLinesFromArray } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import { ProposalValidationError } from 'types/proposalService';

export const ValidationError: React.FC<ProposalValidationError> = (error) => {
  switch (error.type) {
    case 'DEPENDENT_PRODUCT_LINES':
      return (
        <>
          Elect <b>{getProductLinesFromArray(error.productLineIds)}</b> to proceed
        </>
      );
    case 'DOVETAILING':
      return (
        <>
          The combination of STD benefit duration and LTD elimination period that you have selected will result in a
          gap&nbsp;or overlap&nbsp;in coverage. Please revise your selection.
        </>
      );
    case 'REQUIRED_CROSS_SELL':
      return (
        <>
          <b>{error.addedPortfolioName}</b> must be sold with <b>{error.requiredPortfolioName}</b>
        </>
      );
    default:
      return null;
  }
};

export default ValidationError;
